module.exports = __webpack_public_path__ + "img/22.snow-light.be3e40c2.svg";